module.exports = __webpack_public_path__ + "img/c-wx.d1771762.png";